export enum SettingsPlanTemplatesDataEventObjectsEnum {
  PLAN_TEMPLATES_PAGE = 'plan_templates_page',
  PLAN_TEMPLATE_CREATE = 'plan_template_create',
  PLAN_TEMPLATES_EMPTY_STATE = 'plan_templates_empty_state',
  PLAN_TEMPLATE = 'plan_template',
  PLAN_TEMPLATE_SEARCH = 'plan_template_search',
}
